// extracted by mini-css-extract-plugin
export default {"itmCont":"LogerItem_itmCont__lBq95","mainCont":"LogerItem_mainCont__ngVpe","title":"LogerItem_title__+oWZ+"};